import { ActionSubTypes } from '../../ActionSubTypes';
import { IAction, IPropAction } from '../../../models/ActionModels';
import ActionFunctions from '../../core/ActionFunctions';
import { IError } from '../../../models/StateModels';

export const action_page_loaded = (): IAction => {
  return ActionFunctions.action_page_loaded(ActionSubTypes.PAGE_OYAKKIRAKIRAYAVERILENTASINMAZLAR);
};

export const action_page_unloaded = (): IAction => {
  return ActionFunctions.action_page_unloaded(
    ActionSubTypes.PAGE_OYAKKIRAKIRAYAVERILENTASINMAZLAR
  );
};

export const action_page_props_sent = <T>(
  data: T,
  error?: IError | null | undefined
): IPropAction<T> => {
  return ActionFunctions.action_page_props_sent<T>(
    ActionSubTypes.PAGE_OYAKKIRAKIRAYAVERILENTASINMAZLAR,
    data,
    error
  );
};
